// extracted by mini-css-extract-plugin
export default {"content":"TnpViad6RuktI_ahfH7h","subtitle":"cEDlmI5OUBi_yPaouSh5","pdfWithoutBorder":"SJ8zjdfu734kA6X44Lz0","footer":"sV6J9WGKKtLsTEaf1duy","actions":"YN7qTVbV1DMHkfyU9FcR"};